/**
 * @title Glide JS Slider
 * @description Slider for Carousels
 */
import Glide from '@glidejs/glide'
import { siblings } from '@glidejs/glide/src/utils/dom'

const slider = () =>
{
    const slider = document.querySelectorAll('.glide');
    if (slider.length) {

        const SliderClasses = function(Glide, Components, Events) {
            var Component = {

                // Run the function when the slider has mounted
                mount() {
                    this.numbersWidth();
                    this.displayCaption();
                },

                // Update the number
                getCurrentSlide() {
                    let slide = Components.Html.slides[Glide.index];
                    const parent = slide.closest('.glide__track');
                    const currentSlide = parent.querySelector('#sliderNumbers #current-slide');

                    if (currentSlide) {
                        currentSlide.innerText = parseInt(slide.dataset.index);
                    }

                },

                // Add Width to the Numbers based on active slide width
                numbersWidth() {
                    let slide = Components.Html.slides[Glide.index];
                    const parent = slide.closest('.glide__track');

                    const numberContainer = parent.querySelector('#sliderNumbers');

                    if (numberContainer) {
                        numberContainer.style.width = slide.clientWidth + 'px';
                    }
                },

                // Display Caption on Active Slide
                displayCaption() {

                    // Hide all captions which aren't the active slide
                    Array.prototype.forEach.call(Components.Html.slides, function(el, i) {
                        const allCaptions = el.querySelector('.image-caption');

                        if (allCaptions) {
                            allCaptions.classList.add('opacity-0');
                        }
                    });

                    // Show the caption on the active slide
                    let slide = Components.Html.slides[Glide.index];
                    const caption = slide.querySelector('.image-caption');

                    console.log(slide);

                    if (caption) {
                        caption.classList.remove('opacity-0');
                    }
                }

            };

            // Lets change the width when we resize as we have breakpoints on the slider
            Events.on('resize', function () {
                Component.numbersWidth();
            })

            Events.on('move.after', function() {
                Component.getCurrentSlide();
                Component.displayCaption();
            })

            return Component;
        };

        new Glide('.glide', {
            type: 'carousel',
            perView: 1.3,
            gap: 20,
            focusAt: 'center',
            breakpoints: {
                1920: {
                    perView: 1.33,
                },
                1500: {
                    perView: 1.28,
                },
                1440: {
                    perView: 1.285,
                },
                1200: {
                    perView: 1.305,
                },
                1025: {
                    perView: 1.325,
                },
                800: {
                    perView: 2.2,
                    focusAt: 0,
                },
                480: {
                    perView: 1.2,
                    focusAt: 0,
                }
            }
        }).mount({
            'SliderClasses': SliderClasses
        })

    }
}

export { slider }
